import { render, staticRenderFns } from "./Subnavbar-inventario.vue?vue&type=template&id=7144fd24&scoped=true"
import script from "./Subnavbar-inventario.vue?vue&type=script&lang=js"
export * from "./Subnavbar-inventario.vue?vue&type=script&lang=js"
import style0 from "./Subnavbar-inventario.vue?vue&type=style&index=0&id=7144fd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7144fd24",
  null
  
)

export default component.exports